module.exports = __webpack_public_path__ + "img/team_jughead.0578e5f0.jpg";